import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiSelectPhoneWithTextInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .mui-label {
    margin-top: 7px;
    line-height: 18px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black5};
    }
  }
  .asterisk {
    color: ${COLORS.cirrus_red};
  }

  .errorState {
    margin-top: 8px;
    line-height: 14px;
    color: #d32f2f;
    display: flex;
    flex-direction: row;
  }

  .errorState-border {
    border: 2px solid ${COLORS.cirrus_red};
  }

  .errorState-border.react-tel-input:focus-within,
  .errorState-border.react-tel-input:hover {
    border: 2px solid ${COLORS.cirrus_red};
  }
`;
